import AddReactionsIcon from '@shared/assets/icons/v2/add-reactions.svg';
import { ButtonView, ButtonViewProps } from '@shared/components/View';
import styles from './ReactionButton.module.css';

export type ReactionButtonProps = ButtonViewProps;

export function ReactionButton({ onClick, testID }: ButtonViewProps) {
  return (
    <ButtonView onClick={onClick} testID={testID} className={styles.reactionButton}>
      <AddReactionsIcon />
    </ButtonView>
  );
}
